/**
 * Core's read-only groups (CORE_READONLY_GROUPS) answer writes with 403 {code:"read_only"}. This fetch watch
 * turns that into one calm info toast ("View-only in this workshop", at most every 5 s) instead of leaving
 * the user with a module's generic error. The response is returned untouched; inert unless Core sends that
 * code. The toast is raised on the next tick so it lands after the caller's own error handling.
 */
const MESSAGE = 'View-only in this workshop';
const MIN_INTERVAL_MS = 5000;

function urlOf(input: RequestInfo | URL): string {
  return typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
}

export function installReadOnlyNotice(
  target: { fetch: typeof fetch } = window,
  notify: (message: string) => void,
  now: () => number = Date.now,
): () => void {
  const original = target.fetch;
  let last = -Infinity;
  const wrapped: typeof fetch = async (input, init) => {
    const res = await original.call(target, input as RequestInfo, init);
    try {
      const url = urlOf(input as RequestInfo | URL);
      if (res.status === 403 && (/(^|\/)api\//.test(url) || url.startsWith('/api/'))) {
        const body = await res.clone().json().catch(() => null);
        if (body?.code === 'read_only' && now() - last >= MIN_INTERVAL_MS) {
          last = now();
          setTimeout(() => notify(MESSAGE), 0);
        }
      }
    } catch { /* never interfere with the response */ }
    return res;
  };
  target.fetch = wrapped;
  return () => { target.fetch = original; };
}
